import { defineComponent as _defineComponent } from 'vue'

import DateUtil from "@/modules/utils/dateUtil";

interface Props {
	/**
	 * リプライ投稿日。
	 */
	replyDate: string;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    replyDate: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * リプライ投稿日。
	 */
	replyDate: string;
}
/**
 * リプライ情報 > 投稿日。
 */


/**
 * 投稿日を表示用形式に変換。
 * ユーザーの入力値で動的に変更される値ではない為、reactiveにする必要はなし。
 */
const convertDate: string = DateUtil.convertDiplayFormat(props.replyDate);

const __returned__ = { props, convertDate }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})